import React from 'react';

class Checkmark extends React.Component {
  render() {
    return (
      <svg
        width="16px"
        height="12px"
        viewBox="0 0 16 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs></defs>
        <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <g
            id="11-01_Portfolio_Empty-States-Copy-22"
            transform="translate(-351.000000, -134.000000)"
            fillRule="nonzero"
            fill="#FFFFFF"
          >
            <g id="Progress-Bar" transform="translate(344.000000, 125.000000)">
              <g id="step-1-copy">
                <polygon
                  id="Shape"
                  points="12.0149255 18.4925373 8.25373138 14.7313433 7 15.9850746 12.0149255 21 22.7611945 10.2537313 21.5074631 9"
                ></polygon>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default Checkmark;
